// extracted by mini-css-extract-plugin
export default {"container":"submit_container__EXBBg","header":"submit_header__3coz1","actions":"submit_actions__vPZ+H","button":"submit_button__Po7ql","loader":"submit_loader__Dx5LM"};